export const SIGLA_SAG_SOLICITAR_CTC = 'TCTC'
export const SIGLA_SAG_REVISAO_CTC = 'TREVCTC'
export const SIGLA_SAG_CANCELAR_CTC = 'TCANCTC'

export const TITULO_SOLICITAR_CTC= 'Certidão de Tempo de Contribuição';
export const TITULO_REVISAR_CTC= 'Revisar Certidão de Tempo de Contribuição';
export const TITULO_CANCELAR_CTC= 'Cancelar Certidão de Tempo de Contribuição';


export const DESCRICAO_SERVICO_CANCELAR_CTC = 'É o serviço para cancelar uma Certidão de Tempo de Contribuição já emitida.';
export const DESCRICAO_SERVICO_REVISAR_CTC = 'É o serviço para alterar os dados de uma Certidão de Tempo de Contribuição já emitida.';
export const DESCRICAO_SERVICO_SOLICITAR_CTC = `É o serviço para pedir o documento com os dados de vínculos, remunerações e contribuições ao INSS. <br/><br/> Ele permite que a pessoa que trabalha no serviço público conte esse tempo em um ou dois órgãos de Regime Próprio de Previdência (RPPS) ou militar em que trabalhe.`;
export const DESCRICAO_SERVICO_EMITIR_CTC = `É o serviço para acessar a Certidão de Tempo de Contribuição concedida.`;
export const TEXTO_SIGA_BAIXAR_CERTIDAO = ` <br /><br />Siga para o botão <strong/>Baixar Certidão</strong> para emitir o documento.`;

export const MSG_PEDIDO_CERTIDAO_PENDENTE = `Pedido de certidão em andamento.`;
export const MSG_SIGA_CONSULTAR_PEDIDOS = `Siga para o botão <strong>Consultar Pedidos</strong> para acompanhar ou tente de novo mais tarde.`;

